<template>
  <div class="page page-expertise">
    <div
      v-if="expertise"
      class="page__wrap p-bottom-xxxl-1"
      data-animate="page-wrap"
    >
      <PagesCommonHero
        :hero="expertise.hero"
        v-if="expertise && expertise.hero"
      />

      <WidgetIntroTextBlock
        :text="expertise?.introText"
        class="p-top-xxl-1 row-1 --big-size"
        :class="{ '--align-left': expertise?.alignIntroText === 'left' }"
      />
      <template v-if="expertise && expertise.body && expertise.body.length">
        <section
          data-animate="preloader-opacity"
          class="page-expertise__section-grid"
          v-for="item in expertise.body"
          :key="item.id"
        >
          <template v-if="item.__typename === 'GridSectionRecord'">
            <WidgetContentStickyExsud
              :title="item.title"
              :align-left="item.alignment === 'left' ? true : false"
              class="row-1"
            >
              <template v-slot:content>
                <PagesCommonGridParallax
                  v-for="(block, indexRow) in item.gridRows"
                  :key="indexRow"
                  :items="block.items"
                  :reverse="indexRow % 2 !== 0"
                  :class="{
                    'm-top-xl-1': indexRow > 0,
                  }"
                  :has-parallax="false"
                  class="-not-homepage"
                />
              </template>
            </WidgetContentStickyExsud>
          </template>
          <template v-if="item.__typename === 'MediaCarouselRecord'">
            <PagesCommonGeneralCarousel
              :item="item"
              :key="item.id"
              class="m-top-xl-1"
            />
          </template>
          <template v-if="item.__typename === 'CtaBlockRecord'">
            <div class="row-1 section-cta-block">
              <WidgetBannerCtaSlim
                :key="item.id"
                :banner="item"
                v-if="item.slim"
              />
              <WidgetBannerCta v-else :banner="item" :key="item.id" />
            </div>
          </template>
          <template
            v-if="
              item.__typename === 'AnimatedAccordionRecord' &&
              item.accordionsList.length > 0
            "
          >
            <h3
              v-if="item.title && item.title !== ''"
              class="title-xl-1 is-text-center m-bottom-xl-1 row-1"
              v-anim-reveal-text
            >
              {{ item.title }}
            </h3>
            <WidgetAnimatedAccordions
              :accordions-list="item.accordionsList"
              :show-indexes="false"
              class="row-1"
            />
          </template>
          <template v-if="item.__typename === 'BenefitsBlockRecord'">
            <div
              v-if="item.title && item.title !== ''"
              class="title-m-3 is-text-center is-text-uppercase m-bottom-xl-1 row-1"
              v-anim-reveal-text
              v-html="item.title"
            />
            <PagesTechnologyBenefits :list="item.texts" class="row-1" />
          </template>
          <template v-if="item.__typename === 'ApplicationsBlockRecord'">
            <div
              v-html="item.title"
              v-if="item.title && item.title !== ''"
              class="title-xl-1 is-text-center m-bottom-xl-1 m-top-l-1 row-1"
              v-anim-reveal-text
            />
            <PagesCommonApplications
              :list="item.texts"
              class="row-1 m-top-l-1"
            />
          </template>
          <template v-if="item.__typename === 'ServicesBlockRecord'">
            <PagesTechnologyServices
              :title="item.title"
              :services="item.texts"
              class="row-1"
            />
          </template>
          <template v-if="item.__typename === 'IndustriesBlockRecord'">
            <template v-if="page?.ctaDefaultPosition === 'top-industries'">
              <template v-if="expertise?.ctaType === 'Custom'">
                <div
                  v-if="expertise.contactBannerBlock"
                  class="row-1 m-top-xl-1"
                >
                  <WidgetBannerCtaSlim :banner="expertise.contactBannerBlock" />
                </div>
              </template>
              <template v-else>
                <div class="row-1 m-top-xl-1">
                  <client-only>
                    <!--<ContactBanner v-if="contactBanner || contactBanner2"
              :type="expertise?.ctaType === 'Contact Banner 2' ? 2 : 1"
               :banner="expertise.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
            />-->
                    <WidgetBannerCtaSlim
                      v-if="contactBanner || contactBanner2"
                      :banner="
                        expertise.ctaType === 'Contact Banner 2' &&
                        contactBanner2
                          ? contactBanner2
                          : contactBanner
                      "
                    />
                  </client-only>
                </div>
              </template>
            </template>

            <section
              class="--grey-background p-top-m-1 m-top-xl-1 p-bottom-m-1 industries-block-section"
            >
              <div class="row-1">
                <template v-if="industriesContent">
                  <div
                    v-if="item.title !== ''"
                    class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                    v-html="item.title"
                    v-anim-reveal-text
                  />
                  <div
                    v-else
                    class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                    v-html="industriesContent.block.title"
                    v-anim-reveal-text
                  />
                  <div
                    v-if="item.text !== ''"
                    class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                    v-html="item.text"
                    v-anim-reveal-text
                  />
                  <div
                    v-else
                    class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                    v-html="industriesContent.block.text"
                    v-anim-reveal-text
                  />
                </template>

                <PagesHomeTechnologyList
                  :industries="allIndustries"
                  class="p-bottom-m-1"
                  v-if="!item.showCarousel"
                />
              </div>
              <template v-if="item.showCarousel">
                <PagesIndustriesCarousel
                  :slides="allIndustries"
                  :item="{ isVertical: true }"
                />
              </template>
            </section>
          </template>
          <template v-if="item.__typename === 'ClinicalAreasBlockRecord'">
            <template v-if="expertise?.ctaDefaultPosition === 'top-clinical'">
              <template v-if="expertise?.ctaType === 'Custom'">
                <div
                  v-if="expertise.contactBannerBlock"
                  class="row-1 m-top-xl-1"
                >
                  <WidgetBannerCtaSlim :banner="expertise.contactBannerBlock" />
                </div>
              </template>
              <template v-else>
                <div class="row-1 m-top-xl-1">
                  <client-only>
                    <!--<ContactBanner v-if="contactBanner || contactBanner2"
              :type="expertise?.ctaType === 'Contact Banner 2' ? 2 : 1"
               :banner="expertise.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
            />-->
                    <WidgetBannerCtaSlim
                      v-if="contactBanner || contactBanner2"
                      :banner="
                        expertise.ctaType === 'Contact Banner 2' &&
                        contactBanner2
                          ? contactBanner2
                          : contactBanner
                      "
                    />
                  </client-only>
                </div>
              </template>
            </template>
            <template
              v-if="
                clinicalAreas &&
                clinicalAreas.aree &&
                clinicalAreas.aree.length > 0
              "
            >
              <section
                class="--grey-background p-top-m-1 p-bottom-m-1 clinical-block-section"
              >
                <div class="row-1">
                  <template v-if="clinicalAreasContent">
                    <div
                      v-if="item.title !== ''"
                      class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                      v-html="item.title"
                      v-anim-reveal-text
                    />
                    <div
                      v-else
                      class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                      v-html="clinicalAreasContent.block.title"
                      v-anim-reveal-text
                    />
                  </template>
                  <template v-else>
                    <div
                      v-if="item.title !== ''"
                      class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                      v-html="item.title"
                      v-anim-reveal-text
                    />
                  </template>
                  <template v-if="clinicalAreasContent">
                    <div
                      v-if="item.text !== ''"
                      class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                      v-html="item.text"
                      v-anim-reveal-text
                    />
                    <div
                      v-else
                      class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                      v-html="clinicalAreasContent.block.text"
                      v-anim-reveal-text
                    />
                  </template>
                  <template v-else>
                    <div
                      v-if="item.text !== ''"
                      class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                      v-html="item.text"
                      v-anim-reveal-text
                    />
                  </template>
                </div>
                <client-only>
                  <!--  <NuxtMarquee :speed="60" :autofill="true" :class="'clinical-areas-marquee m-top-l-1'">
                        <template v-for="area in clinicalAreas.aree" :key="area.id">
                          <PagesClinicalAreasBlock :item="area" />
                        </template>
                      </NuxtMarquee>-->
                  <div class="clinical-areas-carousel__swiper m-top-l-1">
                    <WidgetSliderSwiper
                      :length="clinicalAreas.aree?.length"
                      :small="true"
                    >
                      <template
                        v-for="(slide, index) in clinicalAreas.aree"
                        :key="index"
                        #[`slide-${index}`]
                      >
                        <PagesClinicalAreasBlock :item="slide" />
                      </template>
                    </WidgetSliderSwiper>
                  </div>
                </client-only>

                <div
                  v-if="item.showLink"
                  class="general-content-link-central m-top-1"
                >
                  <nuxt-link
                    :to="localePath({ name: 'clinical-areas' })"
                    class="button-round-1 is-grey"
                  >
                    <span>{{ $t('cta.discover-more') }}</span>
                  </nuxt-link>
                </div>
              </section>
            </template>
          </template>
          <template v-if="item.__typename === 'ClientiLoghiBlockRecord'">
            <template v-if="expertise?.ctaDefaultPosition === 'top-logos'">
              <template v-if="expertise?.ctaType === 'Custom'">
                <div
                  v-if="expertise.contactBannerBlock"
                  class="row-1 m-top-xl-1"
                >
                  <WidgetBannerCtaSlim :banner="expertise.contactBannerBlock" />
                </div>
              </template>
              <template v-else>
                <div class="row-1 m-top-xl-1">
                  <client-only>
                    <!--<ContactBanner v-if="contactBanner || contactBanner2"
              :type="expertise?.ctaType === 'Contact Banner 2' ? 2 : 1"
               :banner="expertise.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
            />-->
                    <WidgetBannerCtaSlim
                      v-if="contactBanner || contactBanner2"
                      :banner="
                        expertise.ctaType === 'Contact Banner 2' &&
                        contactBanner2
                          ? contactBanner2
                          : contactBanner
                      "
                    />
                  </client-only>
                </div>
              </template>
            </template>
            <section
              v-if="clienti"
              class="clienti-logos-section m-top-xl-1 show-for-large"
            >
              <div class="row-1">
                <div
                  v-html="item.title !== '' ? item.title : clienti.title"
                  class="title-m-3 is-text-center m-bottom-l-1 is-text-uppercase"
                  v-anim-reveal-text
                />
                <PagesStudioImagesGrid :images="clienti.imagesList" />
              </div>
            </section>
          </template>
          <template v-if="item.__typename === 'LinkBlockRecord'">
            <div class="row-1">
              <div class="general-content-link-central m-top-l-2">
                <WidgetLink
                  v-if="item.internalLink"
                  :link="{
                    label: item.linkLabel,
                    link: item.internalLink,
                  }"
                  class="button-round-1 is-big is-gradient-reverse"
                />

                <a
                  v-else
                  :href="item.linkUrl"
                  class="button-round-1 is-big is-gradient-reverse"
                  target="_blank"
                >
                  <span>{{ item.linkLabel }}</span>
                </a>
              </div>
            </div>
          </template>
        </section>
      </template>

      <template v-if="expertise?.ctaDefaultPosition === 'bottom'">
        <template v-if="expertise?.ctaType === 'Custom'">
          <div v-if="expertise.contactBannerBlock" class="row-1 m-top-xl-1">
            <WidgetBannerCtaSlim :banner="expertise.contactBannerBlock" />
          </div>
        </template>
        <template v-else>
          <div class="row-1 m-top-xl-1">
            <client-only>
              <!--<ContactBanner v-if="contactBanner || contactBanner2"
              :type="expertise?.ctaType === 'Contact Banner 2' ? 2 : 1"
               :banner="expertise.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
            />-->
              <WidgetBannerCtaSlim
                v-if="contactBanner || contactBanner2"
                :banner="
                  expertise.ctaType === 'Contact Banner 2' && contactBanner2
                    ? contactBanner2
                    : contactBanner
                "
              />
            </client-only>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'

import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()
const route = useRoute()

const matchMedia = useHelpers().evalMatchMedia('(min-width: 1000px)')

const query = queries.contents.getContent
const variables = computed(() => ({
  locale: locale.value,
  filter: { slug: { eq: route.params.slug } },
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.content) {
  throw createError({ statusCode: 404 })
}

const expertise = computed(() => data.value?.content)
const clienti = computed(() => data.value?.clientiSection)
const industriesContent = computed(() => data.value?.industriesListBlock)
const allIndustries = computed(() => data.value?.allIndustries)
const clinicalAreasContent = computed(() => data.value?.clinicalAreasListBlock)
const clinicalAreas = computed(() => data.value?.clinicalAreaPage)
const contactBanner = computed(() => data.value?.contactBanner)
const contactBanner2 = computed(() => data.value?.contactBanner2)

const seo = computed(() => data.value?.content?.seo || {})
const localeParams = computed(() => expertise.value?._allSlugLocales || [])

// Seo
useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
})

// Functions

const createGrid = (data) =>
  data.map((item) => {
    if (item.__typename === 'ImageVideoBlockRecord') {
      return [mapCol(item)]
    }

    if (item.__typename === 'TwoColGridRecord') {
      return [item.leftColumn, item.rightColumn].map((col) => mapCol(col))
    }

    if (item.__typename === 'ThreeColGridRecord') {
      return [item.leftColumn, item.centerColumn, item.rightColumn].map((col) =>
        mapCol(col)
      )
    }
  })

const mapCol = (item) => ({
  id: item.image?.id,
  image: item.image,
  linkVideo: item.linkVideo,
  alt: item.item?.alt || item.image?.title,

  isVideo: item?.linkVideo ? true : false,
})

useStructuredData().setBreadcrumb({
  section: 'contents',
  title: computed(() => expertise.value?.title),
})

useStructuredData().setService({
  name: computed(() => expertise.value?.title),
  description: computed(
    () => seo.value?.description || expertise.value?.introText,
  ),
})
</script>
